import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createVNode as _createVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-62472d3f")

_pushScopeId("data-v-62472d3f")
const _hoisted_1 = { class: "content gallery" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ImageItem = _resolveComponent("ImageItem")

  return (_openBlock(), _createBlock("section", _hoisted_1, [
    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.artworks, (art, index) => {
      return (_openBlock(), _createBlock("div", {
        class: "artwork",
        key: (index)
      }, [
        (art.pathLong)
          ? (_openBlock(), _createBlock(_component_ImageItem, {
              key: 0,
              class: "art-img",
              id: `art-${index}`,
              source: art.pathLong,
              alt: art.name
            }, null, 8, ["id", "source", "alt"]))
          : _createCommentVNode("", true),
        _createVNode("label", {
          for: `art-${index}`
        }, _toDisplayString(art.name), 9, ["for"])
      ]))
    }), 128))
  ]))
})